
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.0001 10C8.53011 10 5.64011 12.54 5.09011 15.86C4.99011 16.46 5.48011 17 6.09011 17C6.58011 17 6.99011 16.64 7.07011 16.15C7.48011 13.79 9.53011 12 12.0001 12C14.4701 12 16.5201 13.79 16.9301 16.15C17.0101 16.64 17.4201 17 17.9101 17C18.5201 17 19.0001 16.46 18.9001 15.86C18.3601 12.54 15.4701 10 12.0001 10ZM12.0001 6C6.30011 6 1.61011 10.34 1.05011 15.9C1.00011 16.49 1.46011 17 2.06011 17C2.57011 17 3.00011 16.62 3.05011 16.12C3.49011 11.57 7.34011 8 12.0001 8C16.6601 8 20.5101 11.57 20.9601 16.12C21.0101 16.62 21.4401 17 21.9501 17C22.5401 17 23.0101 16.49 22.9501 15.9C22.3901 10.34 17.7001 6 12.0001 6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-looks`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLooks

    ```js
    <b-new-b-icon-looks />
    ```
</docs>


